import { useEffect, useRef } from 'react'
import { useMapLayers } from '@/contexts/MapLayersContext'
import { vijaywadaEvent } from '@/components/map/helper'
import L from 'leaflet'

/**
 * Hook to register Vijayawada event layers with the map context
 * Each module manages its own layers and registers them independently
 */
export function useVijayawadaLayers() {
  const { addLayer, layers, toggleLayer, setLayerOpacity, updateLayer } = useMapLayers()
  const registeredRef = useRef(false)

  // Register Vijayawada layers on mount (only once)
  useEffect(() => {
    if (registeredRef.current) return
    registeredRef.current = true
    
    vijaywadaEvent.forEach((event, index) => {
      const layerId = `vijayawada_${index}`
      
      const bounds = event.bounds
        ? L.latLngBounds(
            L.latLng(event.bounds[1], event.bounds[0]),
            L.latLng(event.bounds[3], event.bounds[2])
          )
        : undefined

      addLayer({
        id: layerId,
        name: event.display_name,
        type: 'tile',
        visible: false,
        opacity: 0.7,
        zIndex: 400,
        metadata: {
          gcs_url: event.gcs_url,
          vmin: event.vmin,
          vmax: event.vmax,
          tiff_name: event.tiff_name,
          colormap_name: event.colormap_name,
          rescale: event.rescale,
          colormap: event.colormap,
          display_name: event.display_name,
        },
        tileConfig: {
          url: event.gcs_url,
          bounds: bounds,
          minZoom: 1,
          maxZoom: 18,
        },
      })
    })
  }, [addLayer])

  // Get Vijayawada layers from the context
  const vijayawadaLayers = layers.filter(l => l.id.startsWith('vijayawada_'))

  return {
    layers: vijayawadaLayers,
    toggleLayer,
    setOpacity: setLayerOpacity,
    updateLayer,
  }
}
